module.exports = __webpack_public_path__ + "static/media/gallery2.26a214e4.jpg";